import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const BrandingContext = createContext(null);
export const useBranding = () => useContext(BrandingContext);

const DEFAULTS = {
  brand_name: "DOMINÓ ROYALLE",
  logo_url: "",
  color_primary: "#D4AF37",
  color_accent: "#10B981",
  color_bg: "#090B0E",
  color_felt: "#0e4a2c",
  landing_headline: "DOMINÓ ONLINE",
  landing_subtitle: "Jogue. Compita. Suba no ranking.",
  landing_description: "Partidas de dominó Double-Six 1x1 em tempo real, com apostas em créditos, cava, cronômetro e prêmios instantâneos na sua carteira.",
  portal_welcome: "Escolha uma sala e entre na fila — pareamento automático 1x1.",
  favicon_url: "",
  slogan: "",
  pix_key: "",
  announcement_enabled: false,
  announcement_type: "info",
  announcement_text: "",
  announcement_modal: false,
};

function applyColors(b) {
  const r = document.documentElement.style;
  if (b.color_primary) r.setProperty("--dr-primary", b.color_primary);
  if (b.color_accent) r.setProperty("--dr-accent", b.color_accent);
  if (b.color_bg) r.setProperty("--dr-bg", b.color_bg);
  if (b.color_felt) r.setProperty("--dr-felt", b.color_felt);
}

function resolveUrl(u) {
  if (!u) return u;
  return u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;
}

function applyBrand(b) {
  applyColors(b);
  if (b.brand_name) document.title = b.slogan ? `${b.brand_name} — ${b.slogan}` : b.brand_name;
  if (b.favicon_url) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = resolveUrl(b.favicon_url);
  }
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding({ ...DEFAULTS, ...data });
      applyBrand(data);
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const applyLocal = (b) => { setBranding((prev) => ({ ...prev, ...b })); applyBrand(b); };

  return (
    <BrandingContext.Provider value={{ branding, setBranding, refresh, applyLocal }}>
      {children}
    </BrandingContext.Provider>
  );
}
